import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPowerPlant: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="power-plant, coal, gas, factory"><path d="M5.75 7.75H10.25L12.25 20.25H3.75L5.75 7.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 3.25H10C8.89543 3.25 8 4.14543 8 5.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.4297 13.25L15.0011 11.5V14L20.2511 11.5V20.25H12.0011" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPowerPlant;
